import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_generic_doc_line_open_queue_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  flow_type: fromDatatype.VarcharDatatypeInterface;
  guid_doc_1_hdr: fromDatatype.GuidDataFieldInterface;
  guid_doc_1_line: fromDatatype.GuidDataFieldInterface;
  server_doc_type_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_type_2: fromDatatype.VarcharDatatypeInterface;
  qty_open: fromDatatype.NumericDatatypeInterface;
  doc_1_line_fi_item_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_code: fromDatatype.VarcharDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  company_code: fromDatatype.VarcharDatatypeInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  branch_code: fromDatatype.VarcharDatatypeInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  location_code: fromDatatype.VarcharDatatypeInterface;
  guid_store_2: fromDatatype.GuidDataFieldInterface;
  location_code_2: fromDatatype.VarcharDatatypeInterface;
  doc_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_code: fromDatatype.VarcharDatatypeInterface;
  tracking_id: fromDatatype.VarcharDatatypeInterface;
  allocation_qty: fromDatatype.NumericDatatypeInterface;
  approval_status: fromDatatype.VarcharDatatypeInterface;
  serial_no: fromDatatype.VarcharDatatypeInterface;
  batch_no: fromDatatype.VarcharDatatypeInterface;
  bin_no: fromDatatype.JsonDatatypeInterface;
}

export class bl_fi_generic_doc_line_open_queue_RowClass
  implements bl_fi_generic_doc_line_open_queue_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  flow_type: fromDatatype.VarcharDatatypeInterface;
  guid_doc_1_hdr: fromDatatype.GuidDataFieldInterface;
  guid_doc_1_line: fromDatatype.GuidDataFieldInterface;
  server_doc_type_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_type_2: fromDatatype.VarcharDatatypeInterface;
  qty_open: fromDatatype.NumericDatatypeInterface;
  doc_1_line_fi_item_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_code: fromDatatype.VarcharDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  company_code: fromDatatype.VarcharDatatypeInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  branch_code: fromDatatype.VarcharDatatypeInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  location_code: fromDatatype.VarcharDatatypeInterface;
  guid_store_2: fromDatatype.GuidDataFieldInterface;
  location_code_2: fromDatatype.VarcharDatatypeInterface;
  doc_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_code: fromDatatype.VarcharDatatypeInterface;
  tracking_id: fromDatatype.VarcharDatatypeInterface;
  allocation_qty: fromDatatype.NumericDatatypeInterface;
  approval_status: fromDatatype.VarcharDatatypeInterface;
  serial_no: fromDatatype.VarcharDatatypeInterface;
  batch_no: fromDatatype.VarcharDatatypeInterface;
  bin_no: fromDatatype.JsonDatatypeInterface;
}
